<shared-modal-box [minHeight]="minHeight" [size]="size" [modalData]="modalData" [mobilePreserve]="mobilePreserve"
    class="modal-type-dynamic-height">

    <shared-modal-top class="modal-type-dynamic-height__top" *ngIf="isTopVisible" directive-height-offset
        [targetId]="'modal-'+modalData.id" (onCloseClick)="handleCloseClick($event)">
    </shared-modal-top>

    <shared-modal-header [borderBottom]="headerBorderBottom" class="modal-type-dynamic-height__header" *ngIf="header"
        directive-height-offset [targetId]="'modal-'+modalData.id">
        <ng-container *ngTemplateOutlet="header"></ng-container>
    </shared-modal-header>

    <shared-modal-sub-header class="modal-type-dynamic-height__sub-header" *ngIf="subHeader" directive-height-offset
        [targetId]="'modal-'+modalData.id">
        <ng-container *ngTemplateOutlet="subHeader"></ng-container>
    </shared-modal-sub-header>


    <shared-modal-content (onScrollInit)="handleScrollInit($event)" (onScrollY)="handleScrollY($event)"
        [dimmedBg]="dimmedBg" [fullPaddings]="fullPaddings" [shadow]="shadow" [shadowBottom]="shadowBottom"
        [shadowTop]="shadowTop" class="modal-type-dynamic-height__content" [minHeight]="minHeight" [center]="center"
        [modalData]="modalData" [dynamicHeight]="dynamicHeight" *ngIf="hasSpecialInstructions">
        <ng-content></ng-content>
    </shared-modal-content>

    <shared-modal-footer class="modal-type-dynamic-height__footer" *ngIf="footer" directive-height-offset
        [targetId]="'modal-'+modalData.id" [border]="footerBorder">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </shared-modal-footer>

</shared-modal-box>
